import PropTypes from 'prop-types'
import Benefit from 'model/insurancePlans/benefit/benefit'

class PlanBenefitGroup {
  constructor(init) {
    this._benefits = init.benefits
    this._category_id = init.category_id
    this._display_name = init.display_name
    this._external_notes = init.external_notes
    this._id = init.id
    this._internal_notes = init.internal_notes
    this._navigation_only = init.navigation_only
    this._plan_level = init.plan_level
    this._position = init.position
    this._comment = init.comment
    this._accumulation_period = init.accumulation_period
    this._additional_programs = init.additional_programs
    this._hg_clinical_guidance = init.hg_clinical_guidance
    this._limitations = init.limitations
    this._prior_authorization = init.prior_authorization
    this._provisions = init.provisions
  }

  static shape = {
    benefits: PropTypes.arrayOf(PropTypes.instanceOf(Benefit)),
    category_id: PropTypes.number,
    display_name: PropTypes.string,
    external_notes: PropTypes.string,
    id: PropTypes.number,
    position: PropTypes.number,
    internal_notes: PropTypes.string,
    navigation_only: PropTypes.bool,
    plan_level: PropTypes.bool,
    comment: PropTypes.string
  }

  get benefits() {
    return this._benefits || []
  }

  get category_id() {
    return this._category_id
  }

  get comment() {
    return this._comment
  }

  get display_name() {
    return this._display_name || ''
  }

  get external_notes() {
    return this._external_notes
  }

  get id() {
    return this._id
  }

  get internal_notes() {
    return this._internal_notes || ''
  }

  get position() {
    return this._position || null
  }

  set position(name) {
    this._position = name
  }

  get navigation_only() {
    return this._navigation_only
  }

  get plan_level() {
    return this._plan_level
  }

  get accumulation_period() {
    return this._accumulation_period || ''
  }

  get additional_programs() {
    return this._additional_programs || ''
  }

  get hg_clinical_guidance() {
    return this._hg_clinical_guidance || ''
  }

  get limitations() {
    return this._limitations || ''
  }

  get prior_authorization() {
    return this._prior_authorization || ''
  }

  get provisions() {
    return this._provisions || ''
  }
}

export default PlanBenefitGroup
